import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import Partnercard from "./PartnerCard";
import laptopImg from "../../Assets/partners.png";
import Toolstack from "./Toolstack";
import Card from "react-bootstrap/Card";

function Partners() {

  return (
    <Container fluid className="about-section partners-page">
      <Particle />
      <Container className="partners-container">
        <header className="partners-hero">
          <h1 className="partners-hero-title">
            Partners with <strong className="purple">Purpose</strong>
          </h1>
          <p className="partners-hero-lead">
            Collaboration that strengthens neighborhoods and helps communities thrive.
          </p>
        </header>

        <Row className="partners-top" style={{ justifyContent: "center" }}>
          <Col md={7} className="partners-left">
            <Partnercard />
          </Col>

          <Col md={5} className="partners-right">
            <div className="policy-card partners-image-card">
              <img src={laptopImg} alt="Partners" className="partners-image" />
            </div>
          </Col>
        </Row>

        <h2 className="partners-section-heading">
          How We <strong className="purple">Connect</strong> with Partners
        </h2>

        <Card className="policy-card partners-connect-card">
          <Card.Body>
            <blockquote className="blockquote mb-0">
              <p className="about-text partners-connect-paragraph">
                <span className="purple">Community-Building Activities</span>
                <br />
                From homework tutoring and youth tech clubs to urban gardening, our open events bring neighbors together, nurture
                friendships, and inspire collective service.
              </p>

              <p className="about-text partners-connect-paragraph">
                <span className="purple">Social Action &amp; Dialogue</span>
                <br />
                We collaborate with organizations and thought leaders to address critical issues such as technological inequality and
                economic justice, fostering conversations that lead to meaningful solutions.
              </p>

              <p className="about-text partners-connect-paragraph">
                <span className="purple">Collaboration with Tech Companies</span>
                <br />
                We work alongside technology partners who share our vision of inclusive social and economic development, creating tools
                and opportunities that serve communities.
              </p>

              <p className="about-text partners-connect-paragraph partners-connect-paragraph-last">
                <span className="purple">Grassroots Outreach</span>
                <br />
                Through public events, community meetings, and one-on-one conversations, we spread our mission and attract those who
                share our passion for positive change.
              </p>
            </blockquote>
          </Card.Body>
        </Card>

        <h2 className="partners-section-heading">
          <strong className="purple">Our</strong> Partners
        </h2>

        <Toolstack />
      </Container>
    </Container>
  );
}

export default Partners;
